import type { Project } from "@tasduvar/engine";
export interface ProjectSummary { id: string; name: string; updatedAt: string; wallCount: number }
export interface ProjectStore {
  list(): Promise<ProjectSummary[]>;
  load(id: string): Promise<Project | null>;
  /** Bulut deposu kuyruğa aldıysa `{ queued: true }` döner; yerel depo değer döndürmez. */
  save(p: Project, opts?: { force?: boolean; note?: string }): Promise<void | { queued: boolean }>;
  remove(id: string): Promise<void>;
}
export const summarize = (p: Project): ProjectSummary => ({ id: p.id, name: p.info.name, updatedAt: p.updatedAt, wallCount: p.walls.length });
